import { PATHS } from 'src/app/shared/constants/paths';
import { NavigationHelperService } from 'src/app/shared/helpers/navigation.helpers.service';
import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { PlatformService } from '@panamax/app-state';
import { SearchAnalyticsService } from '../../services/search-analytics.service';
import { SearchFilterEnum } from '../models/search-filter.enum';
import { SearchViewModel } from '../models/search-view.model';
import { SEARCH_TYPE } from '@usf/ngrx-product';
import { SEARCH_PAGES_ENUM } from '../../../shared/constants/search-pages.enum';
import { EndecaSearchPagesTypes } from '../../../shared/constants/endeca-search-pages-types';
import { UsfProductCardModeEnum } from '@shared/constants/usf-product-card-mode.enum';

@Component({
  selector: 'app-search-within',
  templateUrl: './search-within.component.html',
  styleUrls: ['./search-within.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SearchWithinComponent implements OnChanges {
  @Input() placeholder: string;
  @Input() searchViewModel: SearchViewModel;
  @Input() type: SearchFilterEnum;
  @Input() originSearchPage: SEARCH_PAGES_ENUM;
  @Input() mode: UsfProductCardModeEnum;
  @Input() productSelectionMode: string;

  searchEnum = SearchFilterEnum;
  searchWithinText = '';
  separator = ' + ';

  constructor(
    readonly platformService: PlatformService,
    private searchAnalyticsService: SearchAnalyticsService,
    private navigationHelper: NavigationHelperService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.searchViewModel?.currentValue) {
      this.searchViewModel = changes.searchViewModel.currentValue;
      this.searchWithinText = this.getSearchWithin();
    }
  }

  getSearchWithin(): string {
    if (!!this.searchViewModel?.searchRequest?.isSearchWithin) {
      return this.searchViewModel?.searchRequest.within;
    } else {
      return '';
    }
  }

  search(searchWithin: any) {
    const text = searchWithin.value;
    if (text === '') {
      this.resetSearchWithin();
      return;
    } else if (text.length < 3) {
      return;
    }

    const queryParams = {
      ...this.searchViewModel.searchRequest,
      isSearchWithin: true,
      within: text,
    };
    const searchType = this.getSearchType();
    this.searchAnalyticsService.trackSearchSubmit(
      queryParams,
      searchType,
      false,
    );

    this.routeTo({
      ...queryParams,
      mode: this.mode,
      productSelectionMode: this.productSelectionMode,
    });
  }

  resetSearchWithin() {
    this.searchWithinText = '';
    if (this.searchViewModel?.searchRequest?.isSearchWithin) {
      const queryParams = {
        ...this.searchViewModel.searchRequest,
        within: '',
        mode: this.mode,
        productSelectionMode: this.productSelectionMode,
        isSearchWithin: false,
      };
      this.routeTo(queryParams);
    }
  }

  routeTo(queryParams) {
    this.navigationHelper.routeTo(PATHS.SEARCH, queryParams);
  }

  getSearchType(): string {
    return this.originSearchPage === SEARCH_PAGES_ENUM.search
      ? SEARCH_TYPE.searchWithinSearch
      : SEARCH_TYPE.catalogSearchWithin;
  }
}
